import React from "react";
import CustomSpinner from '../Shared/CustomSpinner';
import { AuthConsumer } from "./AuthProvider";

export const RedirectCallback = () => (

  <AuthConsumer>
    {({ signinRedirectCallback }) => {
      signinRedirectCallback();
      return <CustomSpinner />;
    }}
  </AuthConsumer>
);

export const LogoutCallback = () => (
  <AuthConsumer>
    {({ signoutRedirectCallback }) => {
      signoutRedirectCallback();
      return <CustomSpinner />;
    }}
  </AuthConsumer>
);

export const Signin = () => (

  <AuthConsumer>
    {({ signinRedirect }) => {
      signinRedirect();
      return <CustomSpinner />;
    }}
  </AuthConsumer>
);
